import request from './request';

const buildingFloors = {
	async getBuildingFloors(query) {
		const response = await request.get('/app/building-floors', query);
		return response;
	},
	async getBuildingFloorGeojson(query) {
		const response = await request.get('/app/building-floors/geojson', query);
		return response;
	},
	async getBuildingFloorNavNodes(query) {
		const response = await request.get('/app/building-floors/nav-nodes', query);
		return response;
	},
	async getBuildingFloorPointOfInterests(query) {
		const response = await request.get('/app/building-floors/point-of-interests', query);
		return response;
	}
};

export default buildingFloors;